import PropTypes from 'prop-types'
import { coffeeWizardDefaults, coffeeWizardProps, product } from '@proptypes'
import TransactionalCardContainer from '../card-container'
import TransactionalProductCard from '../product-card'
import { SubCategoryTitle } from './subcategory-title'

const ProductListTransactional = ({
  coffeeWizard,
  selectedCategoryName,
  name,
  products,
  unavailableForOrderAhead
}) => {
  return (
    <TransactionalCardContainer
      title={
        name ? <SubCategoryTitle count={products.length} name={name} /> : ''
      }
      compact
    >
      {products.map((product, index) => (
        <TransactionalProductCard
          key={product.id}
          position={index + 1}
          selectedCategoryName={selectedCategoryName}
          unavailableForOrderAhead={unavailableForOrderAhead}
          coffeeWizard={coffeeWizard}
          {...product}
        />
      ))}
    </TransactionalCardContainer>
  )
}

ProductListTransactional.propTypes = {
  coffeeWizard: coffeeWizardProps,
  name: PropTypes.string,
  products: PropTypes.arrayOf(product),
  unavailableForOrderAhead: PropTypes.bool,
  selectedCategoryName: PropTypes.string
}

ProductListTransactional.defaultProps = {
  coffeeWizard: coffeeWizardDefaults,
  name: '',
  products: [],
  unavailableForOrderAhead: false,
  selectedCategoryName: ''
}

export default ProductListTransactional
